<template>
  <div class="app-header">
    <div style="display: flex; justify-content: space-between;">
      <div class="app-header__site-title">
        <h1>{{ siteName }}</h1>
      </div>
      <div class="app-header__my-profile">
        <div class="app-header__icon-button-group">
          <nav>
            <router-link v-if="false" :to="{name: 'MyProfile'}" exact-active-class='active'>
              <div>
                <figure>
                  <eva-icon name="info-outline" fill="white" animation="pulse"></eva-icon>
                </figure>
              </div>
            </router-link>
            <router-link v-if="false" to="/courses" exact-active-class='active'>
              <div>
                <figure>
                  <eva-icon name="settings-2-outline" fill="white" animation="pulse"></eva-icon>
                </figure>
              </div>
            </router-link>
            <router-link v-if="false" to="/mailbox" exact-active-class='active'>
              <div>
                <figure>
                  <eva-icon name="message-square-outline" fill="white" animation="pulse"></eva-icon>
                </figure>
              </div>
            </router-link>
            <div @click="logout" style="display: flex; cursor: pointer">
              <figure style="display: flex">
                <span class="material-icons" style="color: white;align-self:center">exit_to_app</span>
              </figure>
              <div style="align-self:center; white-space: nowrap">登出</div>
            </div>
          </nav>
        </div>
        <div class="app-header__my-profile__icon">
          <i>
            <img v-bind:src="profile_icon"/>
          </i>
        </div>
        <div class=app-header__my-profile-detail>
          <div class="app-header__my-profile__user-name">
            {{user.name}}
          </div>
          <div v-if="false">
            <div class="app-header__my-profile__level">
              等級 : {{user.level}}
            </div>
            <div class="app-header__my-profile__exp">
              經驗值 : {{user.exp}}
            </div>
            <div class="app-header__my-profile__exp__bar">
              <div class="app-header__my-profile__exp__bar__container">
                <div class="expValue" v-bind:style="{ width: expPercentage + '%' }">{{user.exp}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="app-left">
      <nav>
        <router-link v-bind:to="tag.to" v-for="(tag, tagIndex) in tags" v-bind:key="tagIndex" :class="{ 'active' : isActive(tag) }">{{tag.text}}</router-link>
      </nav>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .app-left{
    nav {
      display: block;
      a {
        &:not(:last-child) {
          margin-right: 3.5rem;
        }
        &.active {
          color:#96CA31;
        }
        &:not(.active) {
          color: white;
        }
      }
    }
  }
  .app-header {
    line-height: var(--app-header-height);
    padding: 0.5rem calc(var(--app-padding));
    /* justify-content: space-between; */
    background-color:#387E1E;
    color: white;
  }
  .app-header__site-title {
    font-size: 1.5rem;
    font-weight: 700;
  }
  .app-header__my-profile {
    text-align: left;
    display: flex;
    position: relative;
  }
  .app-header__my-profile__icon {
    i {
      max-width: 6.5rem;
      max-height: 6.5rem;
      background: #e9e9e9;
      border-radius: 50%;
      display: block;
      margin: 1rem 1rem;
      overflow: hidden;
      img {
        width: inherit;
      }
    }
  }
  .app-header__my-profile-detail {
    margin: 1rem 0;
    position: relative;
    line-height: 2rem;
    max-width: 10rem;
    white-space: nowrap;
    .app-header__my-profile__exp__bar {
      max-width: 1000px;
      margin: 0 auto;
      padding: 0 0px;
      line-height: 0.5rem;
    }
    .app-header__my-profile__exp__bar__container {
      background-color: #ddd;
      border-radius: 0.5rem;
    }

    .expValue {
      background-color: #FFD900;
      border-radius: 0.5rem;
      color: transparent;
    }
  }
  .app-header__icon-button-group {
    position: relative;
    line-height: 2.5rem;
    margin: 1rem 0 0 0;
  }
  @media screen and (min-width: 1024px) {
    .app-header {
      line-height: calc(var(--app-header-height) * 1.5);
      border-bottom: 1px solid #e9e9e9;
      font-size: 1.25em;
      /* display: flex; */
    }
    .app-left{
      nav {
        display: block;
        a {
          &:not(:last-child) {
            margin-right: 4rem;
          }
          &.active {
            font-weight: 700;
          }
        }
      }
    }
    .app-header__my-profile__icon {
      i {
        width: 6.5rem;
        height: 6.5rem;
        background: #e9e9e9;
        border-radius: 6.5rem;
        display: block;
        margin: 1rem 1rem;
        overflow: hidden;
        img {
          width: inherit;
        }
      }
    }
  }
</style>

<script>
import { EvaIcon } from 'vue-eva-icons'

export default {
  components: {
    [EvaIcon.name]: EvaIcon
  },
  props: {
    tags: Array
  },
  data () {
    return {
      // tags: ['fdsag'],
      siteName: 'Fabulearn@schools',
      expPercentage: 90
    }
  },
  methods: {
    isActive (tag) {
      if (tag.check) {
        return tag.check(this.$route)
      } else {
        let route = tag.to
        console.log(this.$route.matched, route.name)
        return this.$route.matched.some(r => r.name === route.name)
      }
    },
    logout: async function () {
      try {
        await this.$store.dispatch('request', {
          route: 'logout',
          method: 'post'
        })
        this.$store.commit('setUser', null)
      } catch (e) {
        console.log(e)
      }
      window.location.reload()
    }
  },
  computed: {
    profile_icon: function () {
      return this.$store.getters.user.profile_img
    },
    isDashboard () {
      return false
    },
    isCourses () {
      return false
    },
    isAddOns () {
      return false
    },
    user () {
      return this.$store.getters.user
    }
  },
  mounted () {
    // this.get_profile_info()
    this.$store.dispatch('getProfile')
  }

}
</script>
